import { useState, useMemo } from 'react';
import { Plus, Pencil, Trash2, Search } from 'lucide-react';
import { Button, IconButton } from './ui/Button';
import { PageHeader } from './PageHeader';

export function EntityListView({
  title, subtitle, items, columns, loading,
  onAdd, onEdit, onDelete, addLabel = 'Adicionar', emptyText,
  // extraActions opcional: (item) => ReactNode renderizado ANTES dos
  // botoes padrao de edit/delete. Use pra acoes especificas da view
  // (ex: reativar servico inativo).
  extraActions,
}) {
  const [search, setSearch] = useState('');
  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return q ? items.filter(i =>
      (i.razao_social || '').toLowerCase().includes(q) ||
      (i.nome_fantasia || '').toLowerCase().includes(q) ||
      (i.cnpj || '').includes(q) ||
      (i.descricao || '').toLowerCase().includes(q) ||
      (i.codigo || '').toLowerCase().includes(q)
    ) : items;
  }, [items, search]);

  return (
    <div className="fade-in">
      <PageHeader
        title={title}
        subtitle={subtitle}
        actions={<Button icon={Plus} onClick={onAdd}>{addLabel}</Button>}
      />

      <div className="card" style={{ overflow: 'hidden' }}>
        <div style={{ padding: '14px 16px', borderBottom: '1px solid var(--border)', display: 'flex', gap: 8 }}>
          <div style={{ position: 'relative', flex: 1, maxWidth: 360 }}>
            <Search size={14} style={{
              position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)',
              color: 'var(--muted-2)',
            }} />
            <input
              className="input"
              placeholder="Buscar…"
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ paddingLeft: 34 }}
            />
          </div>
          <div style={{ flex: 1 }} />
          <span style={{ fontSize: 12.5, color: 'var(--muted)', alignSelf: 'center' }}>
            {filtered.length} de {items.length}
          </span>
        </div>

        {loading ? (
          <div style={{ padding: '48px 20px', textAlign: 'center', color: 'var(--muted)', fontSize: 13 }}>
            Carregando…
          </div>
        ) : filtered.length === 0 ? (
          <div style={{ padding: '60px 20px', textAlign: 'center', color: 'var(--muted)' }}>
            <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>{emptyText || 'Nada por aqui ainda'}</div>
            <div style={{ fontSize: 13 }}>Comece cadastrando o primeiro registro.</div>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13.5 }}>
              <thead>
                <tr style={{ background: 'var(--surface-2)' }}>
                  {columns.map(c => (
                    <th key={c.key} style={{
                      padding: '11px 16px', textAlign: 'left', fontWeight: 600,
                      fontSize: 11.5, textTransform: 'uppercase', letterSpacing: '.04em',
                      color: 'var(--muted)', borderBottom: '1px solid var(--border)',
                    }}>{c.label}</th>
                  ))}
                  <th style={{ width: 110, padding: '11px 16px', borderBottom: '1px solid var(--border)' }} />
                </tr>
              </thead>
              <tbody>
                {filtered.map(item => (
                  <tr key={item.id} style={{ borderBottom: '1px solid var(--border)' }}
                    onMouseOver={e => e.currentTarget.style.background = 'var(--surface-2)'}
                    onMouseOut={e => e.currentTarget.style.background = 'transparent'}>
                    {columns.map(c => (
                      <td key={c.key} style={{ padding: '13px 16px', verticalAlign: 'middle' }}>
                        {c.render ? c.render(item) : item[c.key]}
                      </td>
                    ))}
                    <td style={{ padding: '8px 16px', textAlign: 'right' }}>
                      <div style={{ display: 'inline-flex', gap: 4 }}>
                        {extraActions ? extraActions(item) : null}
                        <IconButton icon={Pencil} title="Editar" onClick={() => onEdit(item)} />
                        <IconButton icon={Trash2} title="Excluir" onClick={() => onDelete(item)} />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
